var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarninglight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0027 35.4508L30.0466 4.28115C27.3223 -0.305189 20.6813 -0.311283 17.9534 4.28115L0.998145 35.4508C-1.78679 40.1372 1.58493 46.0718 7.04333 46.0718H40.9561C46.4099 46.0718 49.7876 40.142 47.0027 35.4508ZM24 40.4468C22.4496 40.4468 21.1875 39.1847 21.1875 37.6343C21.1875 36.0839 22.4496 34.8218 24 34.8218C25.5504 34.8218 26.8125 36.0839 26.8125 37.6343C26.8125 39.1847 25.5504 40.4468 24 40.4468ZM26.8125 29.1968C26.8125 30.7472 25.5504 32.0093 24 32.0093C22.4496 32.0093 21.1875 30.7472 21.1875 29.1968V15.1343C21.1875 13.5839 22.4496 12.3218 24 12.3218C25.5504 12.3218 26.8125 13.5839 26.8125 15.1343V29.1968Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarninglight);
export default __webpack_public_path__ + "static/media/warninglight.6abfe4a8b744f5f7cc1d23917dac7282.svg";
export { ForwardRef as ReactComponent };